import React from "react";
import Apply from "../Component/Apply/Apply";

function ViewAndAplly() {
  return (
    <div>
      <Apply />
    </div>
  );
}

export default ViewAndAplly;
